/** Egyptian Arabic copy for unit/course/lesson availability and load errors */

export const CONTENT_MESSAGES = {
  unitNotFound: {
    title: 'الوحدة مش موجودة',
    description: 'الوحدة اللي بتدور عليها مش موجودة أو مفيهاش دروس.',
  },
  unitLoadFailed: 'حصل مشكلة وإحنا بنحمّل دروس الوحدة. جرّب تاني.',
  lessonLoadFailed: 'حصل مشكلة وإحنا بنحمّل الدرس. جرّب تاني.',
  lessonContentLoadFailed: 'حصل مشكلة وإحنا بنحمّل محتوى الدرس. جرّب تاني.',
  lessonDetailsLoadFailed: 'مقدرناش نجيب تفاصيل الدرس. جرّب تاني.',
  lessonNotFound: 'الدرس مش موجود دلوقتي.',
  courseLoadFailed: 'حصل مشكلة وإحنا بنحمّل الكورس. جرّب تاني.',
  curriculumLoadFailed: 'مقدرناش نحمّل المنهج. جرّب تاني.',
  noLessons: 'مفيش دروس في الكورس ده دلوقتي.',
  noContent: 'مفيش محتوى متاح دلوقتي.',
  noUnits: 'مفيش وحدات متاحة دلوقتي.',
  noFiles: 'مفيش ملفات للدرس ده.',
  previewUnavailable: 'معاينة النوع ده مش متاحة جوّه الصفحة.',
  contentUnavailable: 'المحتوى مش متاح دلوقتي.',
  unitAccessDenied: 'معندكش صلاحية تفتح الوحدة دي.',
  unitCodeInvalid: 'كود الوحدة غالط أو مش موجود.',
  loginRequired: 'لازم تسجّل دخول الأول.',
  quizMustComplete: 'لازم تخلّص الاختبار اللي قبله الأول.',
  tryAgainSupport: 'جرّب تاني، ولو المشكلة فضلت تواصل مع الدعم.',
  courseNotFound: 'الكورس مش موجود.',
  alreadyEnrolled: 'إنت مسجّل في المحتوى ده أصلاً.',
  insufficientBalance: 'رصيدك مش كفاية لشراء الكورس ده. اشحن المحفظة وحاول تاني.',
} as const;

const MESSAGE_PATTERNS: Array<{ pattern: RegExp; message: string }> = [
  { pattern: /الوحدة غير متوفرة|unit.*not found/i, message: CONTENT_MESSAGES.unitNotFound.title },
  { pattern: /الوحدة غير متاحة|هذه الوحدة غير متاحة|انتهت فترة الوصول/i, message: CONTENT_MESSAGES.contentUnavailable },
  { pattern: /الدرس غير متوفر|lesson.*not found/i, message: CONTENT_MESSAGES.lessonNotFound },
  { pattern: /لا توجد دروس|no lessons/i, message: CONTENT_MESSAGES.noLessons },
  { pattern: /لا توجد وحدات|no enrolled units|no units/i, message: CONTENT_MESSAGES.noUnits },
  { pattern: /لا يوجد محتوى|لا توجد ملفات|no content|no files/i, message: CONTENT_MESSAGES.noContent },
  { pattern: /المحتوى غير متاح|content.*not available|content.*unavailable/i, message: CONTENT_MESSAGES.contentUnavailable },
  { pattern: /غير متاحة|غير متوفر|غير متاح/i, message: CONTENT_MESSAGES.contentUnavailable },
  { pattern: /كود الوحدة|unit code/i, message: CONTENT_MESSAGES.unitCodeInvalid },
  { pattern: /صلاحية|forbidden|403/i, message: CONTENT_MESSAGES.unitAccessDenied },
  { pattern: /تسجيل الدخول|unauthorized|401/i, message: CONTENT_MESSAGES.loginRequired },
  { pattern: /فشل في جلب محتوى الدرس|lesson content/i, message: CONTENT_MESSAGES.lessonContentLoadFailed },
  { pattern: /فشل في جلب دروس الوحدة|unit lessons/i, message: CONTENT_MESSAGES.unitLoadFailed },
  { pattern: /فشل في جلب بيانات الوحدة|unit data/i, message: CONTENT_MESSAGES.unitLoadFailed },
  { pattern: /فشل في تحميل تفاصيل الدرس|lesson details/i, message: CONTENT_MESSAGES.lessonDetailsLoadFailed },
  { pattern: /حدث خطأ أثناء تحميل الدرس|error.*lesson/i, message: CONTENT_MESSAGES.lessonLoadFailed },
  { pattern: /حدث خطأ أثناء تحميل الدورة|error.*course/i, message: CONTENT_MESSAGES.courseLoadFailed },
  { pattern: /فشل في تحميل تفاصيل الدورة/i, message: CONTENT_MESSAGES.courseLoadFailed },
  { pattern: /تاريخ التسجيل غير متوفر/i, message: CONTENT_MESSAGES.contentUnavailable },
  { pattern: /رصيدك غير كاف/i, message: CONTENT_MESSAGES.insufficientBalance },
  { pattern: /مسجّل بالفعل|already enrolled/i, message: CONTENT_MESSAGES.alreadyEnrolled },
  { pattern: /الكورس غير موجود/i, message: CONTENT_MESSAGES.courseNotFound },
];

export function toEgyptianContentMessage(
  raw?: string | null,
  fallback: string = CONTENT_MESSAGES.contentUnavailable
): string {
  if (!raw?.trim()) return fallback;

  const text = raw.trim();
  for (const { pattern, message } of MESSAGE_PATTERNS) {
    if (pattern.test(text)) return message;
  }

  return text;
}
